import { render } from "./VikingsResults.vue?vue&type=template&id=6b590e8c"
import script from "./VikingsResults.vue?vue&type=script&lang=js"
export * from "./VikingsResults.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__